import Fetch from 'jsx/common/util/_fetch';

type PermissionBody = {
  permission: number | number[];
  user?: string;
  group?: string;
};

interface ObjectPermissionBody extends PermissionBody {
  object_id: string;
  content_type: number;
}

export const permission = {
  toggle: async (
    permission: PermissionBody,
    user_permission_id?: number | string | null
  ) => {
    if (user_permission_id)
      return Fetch.delete(`/api/user/permission/${user_permission_id}/`, {
        body: JSON.stringify(permission),
      });

    return Fetch.post(`/api/user/permission/`, {
      body: JSON.stringify(permission),
    });
  },
  objectToggle: async (
    permission: ObjectPermissionBody,
    object_permission_id?: string
  ) => {
    if (object_permission_id)
      return Fetch.delete(
        `/api/user/object-permission/${object_permission_id}/`
      );

    return Fetch.post(`/api/user/object-permission/`, {
      body: JSON.stringify(permission),
    });
  },
  get: async (userId: string) => {
    return Fetch.get(`/api/user/${userId}/permissions/`);
  },
  objectDelete: async (object_permission_ids: string[]) => {
    return Promise.all(
      object_permission_ids.map(id =>
        Fetch.delete(`/api/user/object-permission/${id}/`)
      )
    );
  },
};
